import { Map } from 'immutable';

import ProductRecord from 'records/product';
import { mapProduct } from 'utils/mapToRecord';
import { createSymbols } from 'utils/helpers';
import { resourceReducer } from 'utils/reducerGenerator';

export const {
    EDIT_IN_PRODUCT,
    RESET_PRODUCT,
    SET_PRODUCT,
    TOGGLE_CREATE_PRODUCT_DIALOG,
} = createSymbols([
    'EDIT_IN_PRODUCT',
    'RESET_PRODUCT',
    'SET_PRODUCT',
    'TOGGLE_CREATE_PRODUCT_DIALOG',
]);

const editInProduct = (state, { path, value }) => state.setIn(path, value);
const resetProduct = (state) => state.set('data', ProductRecord(Map({})));
const setProduct = (state, { product }) => state.set('data', ProductRecord(product));
const toggleProductDialog = (state) => state.set('dialogOpen', !state.get('dialogOpen'));

export const { reducer, types } = resourceReducer(
    {
        namespace: 'PRODUCT',
        transformer: mapProduct,
    },
    {
        [EDIT_IN_PRODUCT]: editInProduct,
        [RESET_PRODUCT]: resetProduct,
        [SET_PRODUCT]: setProduct,
        [TOGGLE_CREATE_PRODUCT_DIALOG]: toggleProductDialog,
    }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/product/reducer.js